import React, { FC } from 'react';
import { BoxProps, Theme, styled } from '@material-ui/core';

const CardHeaderWrapper = styled('header')<Theme>(({ theme }) => ({
  position: 'relative',
  borderBottom: `0.75rem solid ${theme.palette.grey['200']}`,
  padding: theme.spacing(6, 8),
}));

type Props = BoxProps;
const CardHeader: FC<Props> = (props) => <CardHeaderWrapper {...props} />;

export default CardHeader;
